/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SearchState } from './SearchState';
import {
    SearchStateFromJSON,
    SearchStateFromJSONTyped,
    SearchStateToJSON,
} from './SearchState';

/**
 * Representation of a Facet Value
 * @export
 * @interface FacetValue
 */
export interface FacetValue {
    /**
     * Name of the facet value
     * @type {string}
     * @memberof FacetValue
     */
    name?: string;
    /**
     * Count of the facet value
     * @type {number}
     * @memberof FacetValue
     */
    count?: number;
    /**
     * 
     * @type {SearchState}
     * @memberof FacetValue
     */
    query?: SearchState;
    /**
     * Flag stating if facet value is selected
     * @type {boolean}
     * @memberof FacetValue
     */
    selected?: boolean;
}

/**
 * Check if a given object implements the FacetValue interface.
 */
export function instanceOfFacetValue(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FacetValueFromJSON(json: any): FacetValue {
    return FacetValueFromJSONTyped(json, false);
}

export function FacetValueFromJSONTyped(json: any, ignoreDiscriminator: boolean): FacetValue {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'count': !exists(json, 'count') ? undefined : json['count'],
        'query': !exists(json, 'query') ? undefined : SearchStateFromJSON(json['query']),
        'selected': !exists(json, 'selected') ? undefined : json['selected'],
    };
}

export function FacetValueToJSON(value?: FacetValue | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'count': value.count,
        'query': SearchStateToJSON(value.query),
        'selected': value.selected,
    };
}

